const actionTypes = {
    UPDATE_SUBSCRIPTIONS: 'UPDATE_SUBSCRIPTIONS',
    UNSUBSCRIBE_AUTOREPLENISHMENT: 'UNSUBSCRIBE_AUTOREPLENISHMENT',
    LOAD_SHIPPING_AND_PAYMENT_INFO: 'LOAD_SHIPPING_AND_PAYMENT_INFO'
};

module.exports = actionTypes;
